import { FunctionBrick, registerBrick } from 'olympe'

export default class Titles extends FunctionBrick {
  /**
   * Executed every time an input (size) gets updated.
   * Note that this method will _not_ be executed if an input value is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {string} size
   * @param {function(string)} setStyle
   */
  onUpdate(context, [size], [setStyle]) {
    // Define the general style #303030
    let style = {
      color: 'black',
      font: 'Roboto',
    }

    // Set the variations
    switch (size) {
      case 'h1':
        style.color = '#303030'
        break
      case 'h2':
        style.color = 'orange'
        break
      case 'h3':
        style.color = 'rgba(123,210,40,0.9)'
        break
      case 'h4':
        style.color = 'pink'
        break
      case 'h5':
        style.color = 'green'
        break
      case 'h6':
        style.color = 'grey'
        break
      default:
        break
    }
    setStyle(JSON.stringify(style))
  }
}

registerBrick('017a16bc53f8e8f19b4c', Titles)
